export function printConsole(valor) 
{   
    if (window.location.hostname==="localhost") 
    {   
        console.log(valor);
    }
    
}